var _circle, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiHealthyCarbs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    fill: "#e3fb94",
    opacity: 0.5,
    r: 12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fill: "#31544e",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.197 6a.23.23 0 00-.198.124.22.22 0 00.02.23l.22.309c.347.488.534 1.069.534 1.664v.182c-.03-.007-.062-.012-.088-.022-.404-.147-.837-.196-1.276-.196C8.526 8.29 7 9.79 7 11.64S8.526 17 10.41 17c.554 0 1.1-.303 1.59-.558.49.255 1.036.557 1.59.558 1.884 0 3.41-3.51 3.41-5.36 0-1.85-1.526-3.35-3.41-3.35-.438 0-.87.05-1.275.197-.026.01-.058.015-.088.022v-.181a3.31 3.31 0 00-.616-1.921l-.22-.31A.226.226 0 0011.197 6zm-.001 3.23a.23.23 0 01.11.022c.53.25.837.201 1.407-.008a.23.23 0 01.247.056.223.223 0 01.04.246.224.224 0 01-.128.116c-.612.224-1.134.288-1.762-.008a.225.225 0 01-.107-.101.22.22 0 01.054-.271.228.228 0 01.139-.053z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.303 7.216l.669-.657a1.773 1.773 0 011.385-.496l1.573.135-1.118.824c-.347.256-.78.373-1.211.328z"
  }))));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--healthy-carbs-8209f3fb65b72682196aca42d1e1b83a.svg";
export { SvgIconUiHealthyCarbs as Component };